import {Component} from "@angular/core";

@Component({
  template:`<div></div>`
})
export  class WizardBaseContentComponent{

  constructor(){
  }
   canMoveForward(params?: string) : boolean{
    return false;
   };
   onValidState(callback, nextStep):void{

   };
   preview(): void{

   };

}



// WEBPACK FOOTER //
// ./src/app/things/shared/wizard/wiz-base.component.ts